<template>
  <v-dialog
    :value="value"
    v-on:input="$emit('input', $event)"
    persistent
    :max-width="!confirm ? '750' : '350'"
  >
    <v-card v-show="!confirm">
      <v-card-title class="headline justify-center">
        <span>メンテナンス作成</span>
      </v-card-title>
      <v-card-text class="mt-4">
        <!-- Title -->
        <label for="title">
          タイトル
          <span class="red--text">*</span>
        </label>
        <v-text-field
          dense
          outlined
          id="title"
          v-model="title"
          :error-messages="titleErrors"
          @input="$v.title.$touch()"
          @blur="$v.title.$touch()"
        ></v-text-field>
        <label for="title">
          詳細
          <span class="red--text">*</span>
        </label>
        <v-textarea
          class="mt-2"
          dense
          outlined
          auto-grow
          v-model="content"
          :error-messages="contentErrors"
          @input="$v.content.$touch()"
          @blur="$v.content.$touch()"
        ></v-textarea>
        <label for="title"> 日時 </label>
        <v-row no-gutters class="mt-2">
          <!-- Start date -->
          <DatePicker
            v-model="startDate"
            :error="dateTimeErrors"
            :disabled="now"
            :min="$moment(new Date()).format('YYYY-MM-DD HH:mm')"
            class="mr-5"
          />
          <!-- Start time -->
          <TimePicker
            v-model="startTime"
            :error="dateTimeErrors"
            :disabled="!startDate || now"
            :key="`start-time-${timePickerKey}`"
            :min="minStartTime"
          />
          <strong class="mt-2 mx-2">から</strong>
          <!-- End date -->
          <DatePicker
            v-model="endDate"
            :min="startDate"
            :disabled="now"
            class="mr-5"
            :key="`end-date-${timePickerKey}`"
          />
          <!-- End time -->
          <TimePicker
            :min="minEndTime"
            class="mr-5"
            v-model="endTime"
            :disabled="!endDate || !startTime || now"
            :key="`end-time-${timePickerKey}`"
          />
          <strong class="mt-2 ml-1">まで</strong>
        </v-row>
        <v-row no-gutters>
          <span class="red--text">{{ dateTimeErrors }}</span>
        </v-row>
        <v-row no-gutters>
          <v-checkbox v-model="now" label="即時メンテナンス"></v-checkbox>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="handleHiddenDialog">キャンセル</v-btn>
        <v-btn
          color="primary"
          class="font-weight-bold"
          @click="handleHideShowConfirm"
          >決定</v-btn
        >
      </v-card-actions>
    </v-card>
    <!-- Dialog confirm -->
    <v-card v-show="confirm">
      <v-card-title class="headline justify-center">
        <span>確認</span>
      </v-card-title>
      <v-card-text class="pb-0"> 登録します。よろしいですか </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="font-weight-bold"
          :loading="loadingCreateMaintain"
          @click="createMaintain"
          small
          >OK</v-btn
        >
        <v-btn @click="handleHideShowConfirm" small>キャンセル</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import mixin from "@/mixin";
import DatePicker from "@/components/DatePicker/DatePicker";
import TimePicker from "@/components/TimePicker/TimePicker";
import { createRecoveMaintain } from "@/api/MasterData.api";
export default {
  props: ["value","data"],
  mixins: [mixin.ValidateMaintain],
  components: { DatePicker, TimePicker },
  data() {
    return {
      loadingCreateMaintain: false,
      confirm: false,
      menuStartDate: false,
      title: "",
      content: "",
      startDate: "",
      startTime: "",
      endDate: "",
      endTime: "",
      now: false,
      timePickerKey: 0,
      dateTimeErrors: "",
    };
  },
  computed: {
    minStartTime() {
      const { startDate, $moment } = this;
      if (startDate == $moment(new Date()).format("YYYY-MM-DD")) {
        return $moment(new Date()).add(5, "m").format("HH:mm");
      }
      return "";
    },
    minEndTime() {
      const { startDate, endDate, startTime, $moment } = this;
      var val;
      if (startDate == "" || endDate == "") {
        val = null;
      } else if (startDate == endDate) {
        val = $moment(new Date(`${startDate} ${startTime}`))
          .add(5, "m")
          .format("HH:mm");
      }
      return val;
    },
  },
  watch: {
    startDate: function (val) {
      if (val == "") {
        this.startTime = "";
      }
      this.endDate = "";
      this.endTime = "";
    },
    endDate: function (val) {
      if (val == "") {
        this.endTime = "";
      }
    },
    startTime: function () {
      this.endTime = "";
      this.timePickerKey++;
    },
    endTime: function () {
      this.timePickerKey++;
    },
  },
  methods: {
    async createMaintain() {
      const {
        startDate,
        startTime,
        endDate,
        endTime,
        title,
        content,
        now,
      } = this;
      this.loadingCreateMaintain = true;

      let start_time;
      if (!startDate || !startTime) {
        start_time = "";
      } else {
        start_time = new Date(`${startDate} ${startTime}`).getTime() / 1000;
      }
      let end_time;
      if (!endDate || !endTime) {
        end_time = "";
      } else {
        end_time = new Date(`${endDate} ${endTime}`).getTime() / 1000;
      }
      let params = {
        title,
        content,
        start_time,
        end_time,
        now,
      };
      await createRecoveMaintain(params)
        .then(() => {
          this.$emit("resetList");
          this.$emit("input", false);
        })
        .catch(() => {});
      this.loadingCreateMaintain = false;
    },
    handleHideShowConfirm() {
      const { startDate, startTime } = this;
      this.$v.$touch();
      this.dateTimeErrors = this.checkDateTimeStart(this.now);
      if (!this.$v.$anyError && !this.dateTimeErrors) {
        if (
          new Date(`${startDate} ${startTime}`).getTime() <=
          new Date().getTime()
        ) {
          return this.$toast.error(
            "開始時間は既に過ごしましたのでご確認ください。"
          );
        }
        this.confirm = !this.confirm;
      }
    },
    checkDateTimeStart(now) {
      const { startDate, startTime } = this;
      let start_Time = new Date(`${startDate} ${startTime}`).getTime();
      let time = new Date().getTime();
      if (now) return "";
      if (startDate == "" || startTime == "") {
        return "開始日時を選択してください。";
      } else if (start_Time < time) {
        return "過去の時間が登録できません。";
      }
      return "";
    },
    handleHiddenDialog() {
      this.$v.$reset();
      this.$emit("input", false);
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  min-width: 130px;
  margin-top: 10px;
  font-weight: bold;
}
</style>